
import { MapLocation } from '@/types/location';

// Gamma Game Center Locations
export const gammaGameCenters: MapLocation[] = [
  {
    id: 45001,
    name: "Gamma - Dammam (Ash Shati Ash Sharqi)",
    type: "Game Center",
    devices: 4,
    coordinates: [26.452285381098502, 50.13022697791172],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  },
  {
    id: 45002,
    name: "Gamma - Dammam (An Nada)",
    type: "Game Center",
    devices: 3,
    coordinates: [26.37133170483515, 50.089629149076394],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  },
  {
    id: 45003,
    name: "Gamma - Dammam (King Saud Rd)",
    type: "Game Center",
    devices: 3,
    coordinates: [26.389098755240603, 50.178346177911706],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
